<div *ngIf="isBrowser" [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container mt-4">

    <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

    <div class="row mb-3">
      <div class="col-12">
        <h1 class="text-center" [ngClass]="{'page-title': useRebrandedLayout }">{{ title }}</h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12">
        <ngb-alert
          *ngIf="missingPetReport.reportStatus === petMissingReportStatus.AwaitingModeration ||
                 missingPetReport.reportStatus === petMissingReportStatus.Open"
          class="mb-3 alert text-center"
          [dismissible]="false"
          [type]="missingPetReport.reportType === petMissingReportType.Stolen ? 'danger' : 'warning'">
          <h5 *ngIf="!isMyPet" class="m-0">
            Have you seen {{ missingPetReport.pet.name }}? Call <strong>{{ companyPhoneNumber }}</strong>
          </h5>
          <h5 *ngIf="isMyPet" class="m-0">
            Share your missing pet report below.
          </h5>
        </ngb-alert>
        <ngb-alert
          *ngIf="missingPetReport.reportStatus === petMissingReportStatus.ClosedRejected"
          class="mb-3 alert"
          [dismissible]="false"
          type="danger">
          There's something not quite right with your missing pet report. Please review and try again.
        </ngb-alert>
        <ngb-alert
          *ngIf="missingPetReport.reportStatus === petMissingReportStatus.ClosedDeceased"
          class="mb-3 alert"
          [dismissible]="false"
          type="danger">
          Your missing pet report has now been closed and will no longer be visible to others.
        </ngb-alert>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-8 offset-2 col-md-6 offset-md-3 col-lg-4 offset-lg-0 mb-4">
        <img class="w-100 rounded border" [src]="imgUrl" alt="Pet image">
      </div>

      <div class="col-12 col-lg-8">
        <div class="pet-name d-sm-flex justify-content-between align-items-start">
          <h2>{{ missingPetReport.pet.name }}</h2>
          <div
            *ngIf="isMyPet &&
                   (missingPetReport.reportStatus === petMissingReportStatus.AwaitingModeration ||
                   missingPetReport.reportStatus === petMissingReportStatus.Open ||
                   missingPetReport.reportStatus === petMissingReportStatus.AwaitingClosureFound ||
                   missingPetReport.reportStatus === petMissingReportStatus.AwaitingClosureDeceased ||
                   missingPetReport.reportStatus === petMissingReportStatus.ClosedRejected)"
            ngbDropdown class="d-inline-block float-sm-none float-end"
            placement="bottom-right">
            <button class="btn btn-outline-primary btn-sm mb-2 mt-1" id="dropdownAction" ngbDropdownToggle>
              <fa-icon
                class="me-2"
                [icon]="['fas', 'pencil']" >
              </fa-icon>
              Actions
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownAction">
              <a
                ngbDropdownItem
                [routerLink]="['/lost-and-found', 'missing-pet', missingPetReport.id, 'edit']">
                <fa-icon
                  class="me-2"
                  [icon]="['fas', 'pencil']" >
                </fa-icon>
                Edit report
              </a>
              <button
                ngbDropdownItem
                class="text-danger"
                (click)="closeListing()">
                <fa-icon
                  class="me-2"
                  [icon]="['far', 'circle-xmark']" >
                </fa-icon>
                Close report
              </button>
            </div>
          </div>
        </div>
        <table class="table table-sm lost-pet-info">
          <tbody>
            <tr>
              <td class="fw-bold">
                Breed
              </td>
              <td>
                {{ missingPetReport.pet.breed }}
              </td>
            </tr>
            <tr>
              <td class="fw-bold">
                Gender
              </td>
              <td>
                <span *ngIf="missingPetReport.pet.gender === petGender.Male">Male</span>
                <span *ngIf="missingPetReport.pet.gender === petGender.Female">Female</span>
                <span *ngIf="missingPetReport.pet.gender === petGender.Unknown">Unknown</span>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">
                Colour/Markings
              </td>
              <td>
                {{ missingPetReport.pet.coloursMarkings }}
              </td>
            </tr>
            <tr>
              <td class="fw-bold">
                Last seen
              </td>
              <td>
                Near {{ missingPetReport.lastSeen.location.info?.postcode }}
              </td>
            </tr>
            <tr>
              <td class="fw-bold">
                Date missing
              </td>
              <td>
                {{ missingPetReport.lastSeen.date | date: 'd MMMM y' }}
              </td>
            </tr>
            <tr>
              <td class="fw-bold">
                Reference
              </td>
              <td>
                <span class="badge bg-primary">
                  #{{ missingPetReport.id }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">
                Status
              </td>
              <td>
                <span *ngIf="missingPetReport.reportStatus === petMissingReportStatus.ClosedFound ||
                             missingPetReport.reportStatus === petMissingReportStatus.AwaitingClosureFound"
                      class="badge bg-success">
                  Found
                </span>

                <span *ngIf="missingPetReport.reportStatus === petMissingReportStatus.AwaitingModeration ||
                             missingPetReport.reportStatus === petMissingReportStatus.Open">
                  <span *ngIf="missingPetReport.reportType === petMissingReportType.Missing"
                        class="badge bg-warning text-dark">
                    Missing
                  </span>
                  <span *ngIf="missingPetReport.reportType === petMissingReportType.Stolen"
                        class="badge bg-danger">
                    Stolen
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">
                More info
              </td>
              <td>
                {{ missingPetReport.lastSeen.notes }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <hr class="my-4">

    <div class="row">
      <div class="col-12 text-center">
        <h5>Spread the word</h5>
        <h6>The more people we can share this with, the higher our chances of finding this pet!</h6>
        <div class="mt-3">
          <a
            class="mt-2 btn btn-facebook mx-auto mx-md-3 d-block d-md-inline-block"
            href="{{ shareLinks.facebook }}"
            target="_blank"
            rel="noopener">
            <fa-icon
              class="me-2"
              [icon]="['fab', 'facebook-f']">
            </fa-icon>
            facebook
          </a>
          <a
            class="mt-2 btn btn-twitter mx-auto mx-md-3 d-block d-md-inline-block"
            href="{{ shareLinks.twitter }}"
            target="_blank"
            rel="noopener">
            <fa-icon
              class="me-2"
              [icon]="['fab', 'twitter']">
            </fa-icon>
            twitter
          </a>
          <a
            class="mt-2 btn btn-whatsapp mx-auto mx-md-3 d-block d-md-inline-block"
            href="{{ shareLinks.whatsapp }}"

            rel="noopener"
            data-action="share/whatsapp/share">
            <fa-icon
              class="me-2"
              [icon]="['fab', 'whatsapp']">
            </fa-icon>
            whatsapp
          </a>
        </div>
      </div>
    </div>

    <hr class="my-4">

    <div class="row mt-3">
      <div class="col-12">
        <div ngbAccordion>
          <div ngbAccordionItem="first" #first="ngbAccordionItem" id="last-seen-map" [collapsed]="!startMapOpened" >
            <div ngbAccordionHeader>
              <div class="card border-0">
                <div class="card-header">
                  <div class="row">
                    <div class="col-sm-8">
                      <h4 class="mb-2 mt-2">{{ missingPetReport.pet.name }} was last seen here:</h4>
                    </div>
                    <div class="col-sm-4 text-end">
                      <button
                        ngbAccordionToggle
                        class="btn btn-sm mt-1"
                        [class]="{ 'btn-outline-secondary' : first.collapsed, 'btn-light': !first.collapsed }">
                        {{ !first.collapsed ? 'Hide' : 'See' }} map
                        <fa-icon [icon]="['fas', !first.collapsed ? 'caret-up' : 'caret-down']"></fa-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <google-map
                  *ngIf="mapsReady"
                  [zoom]="missingPetReport.lastSeen.location.latitude && missingPetReport.lastSeen.location.longitude ? 14 : 5"
                  [center]="{
                    lat: missingPetReport.lastSeen.location.latitude || 54.11815748515591,
                    lng: missingPetReport.lastSeen.location.longitude || -2.541813085952347
                  }"
                  [options]="{
                    disableDefaultUI: true,
                    zoomControl: false,
                    cameraControl: true,
                    scrollwheel: false,
                    clickableIcons: false,
                    fullscreenControl: true,
                    draggableCursor: 'default'
                  }"
                  width="100%"
                >
                  <map-circle
                    *ngIf="missingPetReport.lastSeen.location.latitude && missingPetReport.lastSeen.location.longitude"
                    [center]="{
                      lat: missingPetReport.lastSeen.location.latitude,
                      lng: missingPetReport.lastSeen.location.longitude
                    }"
                    [radius]="250"
                    [options]="{
                      fillColor: '#ee7203',
                      strokeColor: '#ee7203',
                      strokeWeight: 1,
                      clickable: false
                    }"
                  >
                  </map-circle>
                </google-map>
              
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="my-4">
  </div>
</div>
